<template>
  <v-row no-gutters>
    <v-col cols="12">
      <span>API Base URL <span class="text-red">*</span></span>
    </v-col>
    <v-col cols="12">
      <v-text-field
        id="txtProviderApiBaseUrl"
        v-model="provider.baseUrl"
        variant="solo"
        density="compact"
        placeholder="API Base URL"
        :error-messages="providerApiBaseUrlErrors"
        @blur="v$.provider.$touch()"
      />
    </v-col>
    <v-col cols="12">
      <span>API Key <span class="text-red">*</span></span>
    </v-col>
    <v-col cols="12">
      <v-text-field
        id="txtProviderApiKey"
        v-model="provider.apiKey"
        variant="solo"
        density="compact"
        placeholder="API Key"
        :error-messages="providerApiKeyErrors"
        @blur="v$.provider.$touch()"
      />
    </v-col>
    <v-col cols="12">
      <span>API Tenant SID <span class="text-red">*</span></span>
    </v-col>
    <v-col cols="12">
      <v-text-field
        id="txtProviderApiTenantSid"
        v-model="provider.tenantSid"
        variant="solo"
        density="compact"
        placeholder="API Tenant SID"
        :error-messages="providerApiTenantSidErrors"
        @blur="v$.provider.$touch()"
      />
    </v-col>
    <v-col cols="12">
      <span>API Report SID <span class="text-red">*</span></span>
    </v-col>
    <v-col cols="12">
      <v-text-field
        id="txtProviderApiReportSid"
        v-model="provider.reportSid"
        variant="solo"
        density="compact"
        placeholder="API Report SID "
        :error-messages="providerApiReportSidErrors"
        @blur="v$.provider.$touch()"
      />
    </v-col>
  </v-row>
</template>
<script>
import { validateUrl } from './validation';
import { useVuelidate } from '@vuelidate/core';

export default {
  name: 'ClientProviderApi',

  props: {
    modelValue: {
      type: Object,
      required: true
    },
    validInput: { type: Boolean, required: false, default: true }
  },

  emits: ['update:model-value', 'update:validInput'],

  setup: () => ({ v$: useVuelidate() }),

  validations() {
    return {
      provider: {
        baseUrl: {
          validateApiBaseUrl: validateUrl
        },
        apiKey: { required: true },
        reportSid: { required: true },
        tenantSid: { required: true }
      }
    };
  },

  data() {
    return {
      provider: { apiKey: '', baseUrl: '', reportSid: '', tenantSid: '' }
    };
  },

  computed: {
    providerApiBaseUrlErrors() {
      const errors = [];
      if (!this.v$ || !this.v$.provider || !this.v$.provider.$dirty) return errors;
      if (!this.provider.baseUrl) {
        errors.push('API Base URL is required');
      } else if (this.v$.provider.baseUrl.validateApiBaseUrl.$invalid) {
        errors.push('Invalid API Base URL');
      }
      return errors;
    },
    providerApiKeyErrors() {
      const errors = [];
      if (!this.v$ || !this.v$.provider || !this.v$.provider.$dirty) return errors;
      if (!this.provider.apiKey) {
        errors.push('API Key is required');
      }

      return errors;
    },
    providerApiTenantSidErrors() {
      const errors = [];
      if (!this.v$ || !this.v$.provider || !this.v$.provider.$dirty) return errors;
      if (!this.provider.tenantSid) {
        errors.push('API Tenant SID is required');
      }
      return errors;
    },
    providerApiReportSidErrors() {
      const errors = [];
      if (!this.v$ || !this.v$.provider || !this.v$.provider.$dirty) return errors;
      if (!this.provider.reportSid) {
        errors.push('API Report SID is required');
      }
      return errors;
    },
    isValidInput() {
      if (!this.v$ || !this.v$.provider || !this.v$.provider.$dirty) return false;

      const errors = this.providerApiBaseUrlErrors
        .concat(this.providerApiKeyErrors)
        .concat(this.providerApiTenantSidErrors)
        .concat(this.providerApiReportSidErrors);
      if (errors.length > 0) {
        return false;
      }
      return true;
    }
  },

  watch: {
    modelValue(newValue) {
      this.resetData(newValue);
    },
    provider: {
      deep: true,
      handler(newValue) {
        this.$emit('update:model-value', newValue);
        if (this.validInput !== this.isValidInput) {
          this.$emit('update:validInput', this.isValidInput);
        }
      }
    },
    isValidInput(newValue) {
      this.$emit('update:validInput', newValue);
    }
  },

  async mounted() {
    this.resetData(this.modelValue);
    const { apiKey, baseUrl, reportSid, tenantSid } = this.modelValue || {};
    if (apiKey || baseUrl || reportSid || tenantSid) {
      this.v$.provider.$touch();
    } else {
      this.v$.provider.$reset();
    }
  },

  methods: {
    async resetData(newValue) {
      const { apiKey, baseUrl, reportSid, tenantSid } = newValue || {};
      this.provider.apiKey = apiKey || '';
      this.provider.baseUrl = baseUrl || '';
      this.provider.reportSid = reportSid || '';
      this.provider.tenantSid = tenantSid || '';
      if (this.validInput !== this.isValidInput) {
        this.$emit('update:validInput', this.isValidInput);
      }
    }
  }
};
</script>
<style scoped></style>
